import { BaseModel } from '@tcc-mono/shared/data-access';


export class HealthRegistration extends BaseModel {
  id: number;
  name: string;
  date: string;
  number: number;
  age_in_weeks: number;
  hema_week_number: number;
  created_at: string;
  updated_at: string;
  animal_count: number;
  lines: HealthRegistrationLine[];
}

export class HealthRegistrationLine {
  identification_number: string;
  country_code: string;
  injection: string;
  hb_measure_1: string;
  hb_measure_2: string;
  hb_measure_3: string;
  hb_measure_4: string;
  hb_measure_5: string;
  serum_measure_1: string;
  serum_measure_2: string;
  serum_measure_3: string;
  serum_measure_4: string;
  serum_measure_5: string;
}
